<main *ngIf="!btnSpecialCaseURL?.url">
    <app-header #header *ngIf="!isMobile && isDefaultLayoutEnabled" [pageType]="pageType"></app-header>
    <div id="router-outlet">
        <router-outlet></router-outlet>
    </div>
    <app-footer #footer *ngIf="!isMobile && isDefaultLayoutEnabled" [pageType]="pageType"></app-footer>
    <app-widget *ngIf="!isMobile && isDefaultLayoutEnabled" [pageType]="pageType"></app-widget>
    <app-full-loader [pageType]="pageType"></app-full-loader>
    <app-full-loader-with-msg [pageType]="pageType"></app-full-loader-with-msg>
    <app-toast></app-toast>
    <!-- <app-chat-bot *ngIf="!isMobile && isDefaultLayoutEnabled"></app-chat-bot> -->
</main>
<a #btnSpecialCaseMain class="!hidden" [routerLink]="btnSpecialCaseURL.url" [queryParams]="getQueryParams()">
    [hidden-btn]
</a>